import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ussd-payment',
  templateUrl: './ussd-payment.component.html',
  styleUrls: ['./ussd-payment.component.scss']
})
export class UssdPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
